export default "__VITE_ASSET__t5a9qb_b__"